module.exports = {
      id: "corona-updates-icon-usage",
      viewBox: "0 0 25.374 25.18",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#corona-updates-icon",
      toString: function () {
        return this.url;
      }
    }